import { render, staticRenderFns } from "./departmanagetable.vue?vue&type=template&id=07800ed3&scoped=true&"
import script from "./departmanagetable.vue?vue&type=script&lang=js&"
export * from "./departmanagetable.vue?vue&type=script&lang=js&"
import style0 from "./departmanagetable.vue?vue&type=style&index=0&id=07800ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07800ed3",
  null
  
)

export default component.exports